.button {
  box-shadow: var(--vkui--elevation3);
  background: var(--trigger-button-bg);
  position: fixed;
  right: 16px;
  bottom: calc(var(--vkui_internal--safe_area_inset_bottom) + 16px);
  padding: 12px;
  box-sizing: border-box;
  border-radius: 56px;
  cursor: pointer;
  z-index: 9999;
  color: var(--trigger-button-icon-color);
}

.notifyBadge {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background: #fff;
  border-radius: 50%;

  & .inner {
    background: var(--notify-dot);
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
}
